// extracted by mini-css-extract-plugin
var _1 = "ImageGallery-module__actions__Gkj8c";
var _2 = "ImageGallery-module__dropzone__zbXEL";
var _3 = "ImageGallery-module__galleryGrid__P9TSp";
var _4 = "ImageGallery-module__galleryHeading__TsJuY";
var _5 = "ImageGallery-module__imageCard__sxlUj";
var _6 = "ImageGallery-module__overlay__cfHPx";
var _7 = "ImageGallery-module__previewGrid__F__bt";
var _8 = "ImageGallery-module__previewImage__f1Yj2";
var _9 = "ImageGallery-module__uploadSection__Qb6Ma";
var _a = "ImageGallery-module__uploadText__n5F24";
export { _1 as "actions", _2 as "dropzone", _3 as "galleryGrid", _4 as "galleryHeading", _5 as "imageCard", _6 as "overlay", _7 as "previewGrid", _8 as "previewImage", _9 as "uploadSection", _a as "uploadText" }
